import {useDispatch, useSelector} from 'react-redux';
import React from 'react';
import {getTypedModalState} from '../../stores/selectors/typedModalSelectors';
import {ModalType} from '../../constants/dataEnum';
import ModalMissingTray from './missingTrayModal/ModalMissingTray';
import {showIncompatibleVisionVersionModal} from '../../stores/business/softwareUpdaterBusiness';
import ModalSetTrayID from '../ModalSetTrayID';
import ModalReturnTipsConfirmation from './returnTipsModal/ModalReturnTipsConfirmation';
import ModalBackupAndRestoreData from './backupAndRestoreDataModal/ModalBackupAndRestoreData';
import ModalDownloadBackupDataFailed from './backupAndRestoreDataModal/ModalDownloadBackupDataFailed';
import ModalPlateRecognition from './plateRecognitionModal/ModalPlateRecognition';
import ModalInvalidPlateRecognition from './invalidPlateRecognitionModal/ModalInvalidPlateRecognition';
import ModalHumidifierDisconnected from './humidifier/ModalHumidifierDisconnected';
import ModalCaddyDetection from './caddyDetectionModal/ModalCaddyDetection';
import ModalCannotUseThisFeature from './serviceError/ModalCannotUseThisFeature';
import ModalInstrumentNonOperational from './serviceError/ModalInstrumentNonOperational';
import ModalIdleHumidity from './idleHumidityModal/ModalIdleHumidity';

function TypedModalContainer() {
  const dispatch = useDispatch();

  const typedModalState = useSelector(getTypedModalState);
  const {isShown, modalType} = typedModalState || {};

  return isShown ? (
    <>
      {modalType === ModalType.NO_TRAY_ID_FOUND_ERROR && <ModalSetTrayID />}
      {modalType === ModalType.INCOMPATIBLE_VISION_VERSION && dispatch(showIncompatibleVisionVersionModal())}
      {modalType === ModalType.MISSING_TRAY_ERROR && <ModalMissingTray />}
      {modalType === ModalType.RETURN_TIPS_CONFIRMATION && <ModalReturnTipsConfirmation />}
      {modalType === ModalType.BACKUP_AND_RESTORE_DATA && <ModalBackupAndRestoreData />}
      {modalType === ModalType.DOWNLOAD_BACKUP_DATA_FAILED && <ModalDownloadBackupDataFailed />}
      {modalType === ModalType.PLATE_RECOGNITION && <ModalPlateRecognition />}
      {modalType === ModalType.IDLE_HUMIDITY && <ModalIdleHumidity />}
      {modalType === ModalType.INVALID_PLATE_RECOGNITION && <ModalInvalidPlateRecognition />}
      {modalType === ModalType.HUMIDIFIER_DISCONNECTED && <ModalHumidifierDisconnected />}
      {modalType === ModalType.CADDY_DETECTION && <ModalCaddyDetection />}
      {modalType === ModalType.CANNOT_USE_THIS_FEATURE && <ModalCannotUseThisFeature />}
      {modalType === ModalType.INSTRUMENT_NON_OPERATIONAL && <ModalInstrumentNonOperational />}
    </>
  ) : null;
}

export default TypedModalContainer;
